import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-13731">
      <span className="sr-only" data-id="element-13732">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-13733">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-13734" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-13735" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-13736">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-13737">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-13738" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-13739" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-13740" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-13741">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-13742">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-13743" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-13744" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-13745">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-13746">
            <thead data-id="element-13747">
              <tr data-id="element-13748">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-13749">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-13750" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-13751">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-13752">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-13753">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-13754" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-13755">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-13756" />
          <div className="flex gap-2" data-id="element-13757">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-13758" />)}
          </div>
        </div>
      </div>
    </div>;
}